import { requirePermission } from '../../../require-permission';
import { PermissionResource } from '@entities/tenant/permission';

// Тимчасово беремо пермішен знижок, бо окремого тенант-ресурсу для замовлень
// талонів бекенд ще не завів. Замінити, щойно зʼявиться відповідний Resource.
export const ordersLoader = requirePermission(PermissionResource.TenantDiscounts);
